// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import AutoAwesomeMotion from "@mui/icons-material/AutoAwesomeMotion";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import categoryTableData from "layouts/tables/data/categoriesTableData";
import CategoriesForm from "./components/CategoriesForm";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { Box, Modal, TablePagination, Typography } from "@mui/material";
import { useCategory } from "context/CategoryContext";
import MDModal from "components/MDModal";

function Categories() {
  const [showForm, setShowForm] = useState(false);
  const {
    editCategory,
    msg,
    isOpen,
    setIsOpen,
    title,
    loading,
    currentPage,
    totalPages,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
  } = useCategory();
  const { columns, rows } = categoryTableData();

  const onShowForm = () => setShowForm(!showForm);
  const handleModal = () => setIsOpen(!isOpen);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (Object.keys(editCategory).length != 0) {
      setShowForm(true);
    }
  }, [editCategory]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Categorias
                </MDTypography>
              </MDBox>
              <MDBox>
                <MDBox spacing={5} mb={3} lineHeight={0}>
                  {/* {loading ? <ReactSVG src="assets/images/svg/Rolling@1x-1.0s-200px-200px (1).svg" />
                : */}
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={onShowForm}
                    disable={loading}
                    startIcon={<AutoAwesomeMotion />}
                    sx={{ mt: 4 }}
                    fullWidth
                  >
                    Cadastrar Categorias
                  </MDButton>
                </MDBox>
                {showForm ? <CategoriesForm setShowForm={setShowForm} /> : null}
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <TablePagination
                  component="div"
                  count={totalPages}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Linhas por página:"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {msg}
        </Typography>
        <MDButton variant="gradient" color="info" onClick={() => setIsOpen(false)} fullWidth>
          Fechar
        </MDButton>
      </MDModal>
    </DashboardLayout>
  );
}

Categories.propTypes = {
  editCategory: PropTypes.object,
};

export default Categories;
